import jumpScareUrl from '../../../assets/audio/riza_jumpScare.mp3';

// HTMLMediaElement.volume solo acepta valores entre 0 y 1. La ganancia del
// Web Audio API permite respetar el nivel solicitado de 1.4 sin perder el
// control nativo de reproducción del MP3.
export const ENTRY_REVEAL_GAIN = 1.4;

let sharedAudio = null;
let audioContext = null;
let mediaSource = null;
let gainNode = null;

function getEntryRevealAudio() {
  if (!sharedAudio) {
    sharedAudio = new Audio(jumpScareUrl);
    sharedAudio.preload = 'auto';
    sharedAudio.volume = 1;
  }
  return sharedAudio;
}

function connectAmplifier(audio, resumeContext = true) {
  const Context = window.AudioContext || window.webkitAudioContext;
  if (!Context) return false;

  try {
    if (!audioContext) audioContext = new Context({ latencyHint: 'interactive' });
    if (!mediaSource) {
      mediaSource = audioContext.createMediaElementSource(audio);
      gainNode = audioContext.createGain();
      gainNode.gain.value = ENTRY_REVEAL_GAIN;
      mediaSource.connect(gainNode);
      gainNode.connect(audioContext.destination);
    }
    if (resumeContext && audioContext.state !== 'running') audioContext.resume().catch(() => {});
    return true;
  } catch {
    return false;
  }
}

export function preloadEntryRevealAudio() {
  try {
    const audio = getEntryRevealAudio();
    audio.load();
    // Deja conectado el amplificador antes del reveal. React y CSS solo
    // tendrán que iniciar la reproducción cuando llegue el login.
    connectAmplifier(audio, false);
  } catch {
    // La reproducción volverá a intentarse cuando comience la animación.
  }
}

export function playEntryRevealAudio() {
  try {
    const audio = getEntryRevealAudio();
    audio.pause();
    audio.currentTime = 0;
    audio.volume = 1;
    connectAmplifier(audio, true);
    const attempt = audio.play();
    if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
    return attempt;
  } catch {
    return undefined;
  }
}
